


























import {debounce} from 'lodash-es';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

interface SearchResultResponse {
  id: string;
  name: string;
  link: string;
}

@Component
export default class SearchBox extends Vue {
  @Prop({type: String, default: ''})
  public readonly placeholder: string;

  @Prop({type: String})
  public readonly searchUrl: string;

  protected query: string = '';

  private current = 0;

  protected searchResults: SearchResultResponse[] = [];

  @Watch('query')
  private readonly debouncedRefreshResults = debounce(this.refreshResults, 400);

  protected enter(): void {
    if (this.searchResults.length !== 0) {
      window.location.href = this.searchResults[this.current].link;
    }
  }

  protected up(): void {
    if (this.current > 0) {
      this.current--;
    }
  }

  protected down(): void {
    if (this.current < this.searchResults.length - 1) {
      this.current++;
    }
  }

  protected isActive(id: number): boolean {
    return id === this.current;
  }

  protected clicked(index: number): void {
    this.current = index;
    this.enter();
  }

  protected refreshResults() {
    if (this.query === '') {
      return;
    }

    fetch(this.searchUrl + '?q=' + this.query)
        .then(response => response.json())
        .then(response => {
          this.searchResults = Object.values(response.result);
          this.current = 0;
        });
  }
}
